/* eslint-disable */
import MainService from '@/services/MainService'
import store from '@/store/index'

class Zoho {
  handleError (error:any, handler:any) {
    if (process.env.VUE_APP_NODE_ENV === 'develop') {
      const errorDetail = {
        handler,
        name: error.name,
        message: error.message,
        errorResponse: error
      }
      console.error('There was an error', errorDetail)
    }
  }

  async storeZoho () {
    const storage:any = store.state.storage
    const customer = storage.room.customer
    const category = storage.category

    const data = {
      route: `ocular/rest/zoho/lead`,
      params: customer
    }

    if (category) {
      data.params.categoryUuId = category.uuid
    }

    return MainService.post(data)
      .then((response) => {
        const res = response.data

        if (res.data.id) {
          store.commit('setZohoLeadId', res.data)
        }
      })
      .catch((error) => {
        this.handleError(error, 'Zoho - storeZoho')
      })
  }
}

export default new Zoho()
